import { ELASTIC_SEARCH_MAXIMUM_PAGE } from 'constants/pagination'
import { PageOutOfBoundsError } from 'helpers/errors'
import { FetchProps } from 'helpers/redial'
import { redirectOnWrongPagination } from 'helpers/url'
import { sanitizeQueryParams } from 'store/features/urlManager/helpers'

import { report } from 'helpers/reporter'
import { LIMIT_OUTFIT_RECOS } from './constants'

export default {
  fetch: async ({ t, store, pathname, query }: FetchProps) => {
    const sanitizedQuery = sanitizeQueryParams(query)
    const currentPage = sanitizedQuery.page
      ? parseInt(sanitizedQuery.page, 10)
      : 1

    if (currentPage > ELASTIC_SEARCH_MAXIMUM_PAGE) {
      return redirectOnWrongPagination({
        query,
        to: pathname,
        router: store.router,
        urlManager: store.urlManager,
      })
    }

    const { outfitOverview } = store

    outfitOverview.pagination.currentPage = currentPage

    await outfitOverview.fetchNavigationTree()
    const categoryId = outfitOverview.getOutfitCategoryIdByUrl(pathname)

    try {
      return await Promise.all([
        outfitOverview.fetchSeoInfo({ categoryPath: pathname }).catch(report),
        outfitOverview.fetchOutfits({
          t,
          locale: store.localeStore.locale,
          currentPath: pathname,
          categoryId,
          limit: LIMIT_OUTFIT_RECOS,
        }),
      ])
    } catch (error) {
      if (error instanceof PageOutOfBoundsError) {
        if (outfitOverview.pagination.total !== 0) {
          return redirectOnWrongPagination({
            query,
            to: pathname,
            router: store.router,
            urlManager: store.urlManager,
          })
        } else {
          return outfitOverview.redirectOnNoAvailableOutfits()
        }
      }

      throw error
    }
  },

  defer: async ({ store, query }: FetchProps) => {
    if (query && query.notification === '1') {
      store.outfitOverview.displayUnexistentOutfitNotification()
    }
  },
}
